import { Spin } from 'antd';
import './FullScreenSpin.css'; // 引入样式文件

const FullScreenSpin = ({ spinning = true, tip = 'Loading...' }) => (
  <div className="full-screen-spin">
    <Spin spinning={spinning} tip={tip} size="large" />
  </div>
);

export default FullScreenSpin;
